import { useRouteError } from "react-router";

export const RouterErrorBoundary = (): never => {
  // Just rethrow the error to allow the use of a common error boundary.
  // react-router will by default catch all errors and display a
  // generic error page, and in particular will not report the error
  // to our error reporting service.
  // In particular, it doesn't have a way to handle the error as a
  // callback, which means it's hard to ensure we report the error
  // only once.
  // You also want a router error boundary to catch errors in things like
  // loaders or async component fetching, which don't count as render errors
  // by default, which this resolves.
  throw useRouteError();
};
